it("should parse a self accept with error handler", function() {
	if(module.hot) {
		module.hot.accept(function(err) {
		
		});
	}
});


/*****************
 ** WEBPACK FOOTER
 ** ./parsing/hot-error-handler/index.js
 ** module id = 0
 ** module chunks = 0
 **/